import * as React from 'react';
import { Route } from 'react-router-dom';
import { CheckTask } from './CheckTask';
import { Inbox } from './Inbox';
import { Tasks } from './Tasks';
import { WebsiteSearchPage } from './WebsiteSearchPage';
import { WebsiteStaticPage } from './WebsiteStaticPage';
import { WebsiteVideoGuidesPage } from './WebsiteVideoGuidesPage';
import { Hosting } from './Hosting';
import { WebsiteUpgradePlanPage } from './WebsiteUpgradePlanPage';
import LegalDocumentPage from './LegalDocumentPage';
import { privacyPolicyDocument } from './documents/privacyPolicyDocument';
import { termsAndConditionsDocument } from './documents/termsAndConditionsDocument';
import { attendeeBookingCancellationRefundTerms } from './documents/attendeeBookingCancellationRefundTerms';
import { hostPaymentsPayoutTerms } from './documents/hostPaymentsPayoutTerms';

export const getWebsiteOtherRoutes = (): React.ReactNode => (
  <>
    <Route
      path="about-us"
      element={
        <WebsiteStaticPage title="About Us" body="Careerbook helps institutions run and manage learning events." />
      }
    />
    <Route
      path="attendee-booking-cancellation-refund-terms"
      element={<LegalDocumentPage document={attendeeBookingCancellationRefundTerms} />}
    />
    <Route path="check-task/:key" element={<CheckTask />} />
    <Route
      path="get-started"
      element={
        <WebsiteStaticPage title="Get Started" body="Create an account and start hosting events with Careerbook." />
      }
    />
    <Route path="hosting" element={<Hosting />} />
    <Route path="inbox/:convoId?" element={<Inbox />} />
    <Route path="platform-terms" element={<LegalDocumentPage document={termsAndConditionsDocument} />} />
    <Route path="privacy-policy" element={<LegalDocumentPage document={privacyPolicyDocument} />} />
    <Route path="host-payments-payout-terms" element={<LegalDocumentPage document={hostPaymentsPayoutTerms} />} />
    <Route
      path="pricing"
      element={<WebsiteStaticPage title="Pricing" body="Careerbook pricing options for institutions and hosts." />}
    />
    <Route path="search" element={<WebsiteSearchPage />} />
    <Route path="tasks" element={<Tasks />} />
    <Route path="upgrade-plan" element={<WebsiteUpgradePlanPage />} />
    <Route path="video-guides" element={<WebsiteVideoGuidesPage />} />
  </>
);
